import { encryptPhoneNumber } from 'src/utils'
import { Bridge } from 'src/utils/bridge'
import { useChannel } from 'src/provider/ChannelContextProvider'
import { addFlowBreadcrumb } from 'src/utils/sentry/breadcrumbs'

export type SamsungIsPayParams = {
  StartURL: string
  TID?: string
  StartParams?: string
  OrderID?: string
}

const useSamsungPay = () => {
  const { channel } = useChannel()

  /** 다날 삼성페이 ISPAY: Bridge로 중간 페이지 오픈 → form POST */
  const handleSamsungIsPayRequest = (
    { StartURL, TID, StartParams, OrderID }: SamsungIsPayParams,
    isGift?: boolean,
  ) => {
    addFlowBreadcrumb('payment_attempt', 'request', {
      handler: 'handleSamsungIsPayRequest',
      channel,
      payMethod: 'SAMSUNGPAY',
      type: isGift ? 'gift' : 'default',
      orderId: OrderID,
    })

    const isPayData = { StartURL, TID, StartParams, OrderID }
    const externalUrl = `${window.location.origin}/${channel}/samsung/call?data=${encryptPhoneNumber(JSON.stringify(isPayData))}${!!isGift ? '&&isGift=true' : ''}`

    // web: window.open / aos·ios: 외부 브라우저 (다날·빌게이트와 동일)
    Bridge.handleReqExternalOpenUrl(externalUrl)
  }

  return { handleSamsungIsPayRequest }
}

export default useSamsungPay
